export default "__VITE_PUBLIC_ASSET__41b97dbe__"